import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useTicketStatusQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    list: () =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_STATUSES(projectId),
        queryFn: () => api.getTicketStatusesV1(),
        select: commonAPIDataSelector,
      }),
    details: (statusId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.TICKET_STATUS(projectId, statusId),
        queryFn: () => api.getTicketStatusesDetailsV1(statusId),
        select: commonAPIDataSelector,
      }),
  };
};
